import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import "./documentsAgreements.scss";
import { getDPA } from "api";
import Button from "components/atoms/Button/Button";
import CardNew from "components/molecules/Card/CardNew";
import errorToast from "helpers/errorToast";

function DocumentsAgreements() {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadDPA = () => {
    setIsDownloading(true);
    getDPA()
      .then((res) => {
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = "dpa.pdf";
        link.click();
        URL.revokeObjectURL(fileURL);
      })
      .catch((error) => errorToast(error))
      .finally(() => setIsDownloading(false));
  };

  return (
    <CardNew>
      <Row className="mb-3 d-flex align-items-center">
        <Col lg={2} className="col-fixed font-weight-bold font-b1">
          <FormattedMessage id="settings.documents-agreements.privacyPolicy" defaultMessage="Privacy policy" />
        </Col>
        <Col>
          <a target="_blank" href="https://www.cargobase.com/privacy-policy" rel="noreferrer">
            https://www.cargobase.com/privacy-policy
          </a>
        </Col>
      </Row>
      <Row className="mb-3 mt-3 d-flex align-items-center">
        <Col lg={2} className="col-fixed font-weight-bold font-b1">
          <FormattedMessage id="settings.documents-agreements.termsConditions" defaultMessage="Terms & conditions" />
        </Col>
        <Col>
          <a target="_blank" href="https://www.cargobase.com/terms-and-conditions" rel="noreferrer">
            https://www.cargobase.com/terms-and-conditions
          </a>
        </Col>
      </Row>
      <Row className="mt-3 d-flex align-items-center">
        <Col lg={2} className="col-fixed font-weight-bold font-b1">
          <FormattedMessage
            id="settings.documents-agreements.dataProcessingAgreement"
            defaultMessage="Data processing agreement"
          />
        </Col>
        <Col>
          <Button onClick={downloadDPA} isLoading={isDownloading} variant="outline-primary">
            <FormattedMessage id="settings.documents-agreements.downloadAgreement" defaultMessage="Download agreement" />
          </Button>
        </Col>
      </Row>
    </CardNew>
  );
}

export default DocumentsAgreements;
